<template>
    <div class="video-wrapper">
        <el-upload style="width: 100%;height: 200px" drag :accept="accept" action="" :before-upload="beforeUpload"
            :show-file-list="false">
            <div>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">点击或将文件拖拽到这里上传</div>
                <div class="el-upload__tip">支持扩展名：{{ accept }}</div>
            </div>
        </el-upload>
        <div v-if="val" class="file-name">{{ val }}</div>
    </div>
</template>

<script>
import { upload } from "@/api/upload";
export default {
    props: {
        value: {
            type: String,
            default: "",
        },
        accept: {
            type: String,
            default: "pdf,doc,docx",
        },
    },
    data() {
        return {
            val: "",
        };
    },
    watch: {
        value(val) {
            this.val = val;
        },
    },
    methods: {
        beforeUpload(file) {
            upload(file).then(({ code, message, result }) => {
                if (code == 200) {
                    this.val = result;
                    this.$emit("input", this.val);
                } else {
                    this.$message.error(message);
                }
            });
            return false;
        },
    },
};
</script>

<style lang="less" scoped>
.video-wrapper {

    :deep(.el-upload-dragger),
    :deep(.el-upload) {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>